import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import clarity from '@microsoft/clarity';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import 'primereact/resources/themes/arya-blue/theme.css';  //theme
import 'primereact/resources/primereact.min.css';         //core css
import 'primeicons/primeicons.css';                        //icons
import 'primeflex/primeflex.css';                          //flex utilities
import './App.css'

const COOKIE_KEY = 'phennx_cookie_preferences';
const clarityId = "v81xz4ujxa";
let clarityInitialized = false;

const hasAnalyticsConsent = () => {
  try {
    const stored = localStorage.getItem(COOKIE_KEY);
    if (!stored) {
      return false;
    }
    const parsed = JSON.parse(stored);
    return Boolean(parsed?.analytics && parsed?.consentGiven);
  } catch (error) {
    return false;
  }
};

const initClarityIfConsented = () => {
  if (!clarityId || clarityInitialized || !hasAnalyticsConsent()) {
    return;
  }
  clarity.init(clarityId);
  clarityInitialized = true;
};

initClarityIfConsented();
window.addEventListener('cookie-preferences:updated', initClarityIfConsented);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
